<template>
  <button @click="handleSettingsClick()" class="settings-btn">
    <Cog class="settings-btn__icon" />
  </button>
</template>

<script setup>
import { useGlobalStore } from "@/stores/globalStore";
import Cog from "@/components/icons/Cog.vue";
import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";

const globalStore = useGlobalStore();

const handleSettingsClick = () => {
  globalStore.toggleSettings();
};
</script>

<style lang="scss">
.settings-btn {
  align-self: flex-end;
  margin-bottom: 2rem;
  background: none;
  border: none;
  cursor: pointer;

  &__icon {
    g {
      transition: var(--button-icon-transition);
      path {
        stroke: var(--icon-color-default);
      }
    }

    &:hover {
      g {
        opacity: 1;
      }
    }
  }
}
</style>
